module.exports = __webpack_public_path__ + "static/media/image-4.1f33b647.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Catalog/image-4.png
// module id = 261
// module chunks = 0